import { http, HttpResponse, delay } from 'msw';

import {
  mockDivisionEmployeeIds,
  mockDivisions,
} from '@/mocks/data/divisionData';

import { mockOrganizationEmployees } from './employeeHandlers';

export const divisionHandlers = [
  http.get('*/v1/organizations/:organizationId/divisions', async () => {
    await delay();
    return HttpResponse.json(
      { results: mockDivisions, total: mockDivisions.length },
      { status: 200 }
    );
  }),

  http.get(
    '*/v1/organizations/:organizationId/divisions/:divisionId/employees',
    async ({ request, params }) => {
      const { divisionId } = params;
      const url = new URL(request.url);
      const limitParam = url.searchParams.get('limit');
      const offsetParam = url.searchParams.get('offset');

      const employeeIds = mockDivisionEmployeeIds[divisionId as string] ?? [];
      let results = mockOrganizationEmployees.filter(emp =>
        employeeIds.includes(emp.id)
      );

      const total = results.length;
      if (limitParam) {
        const limit = parseInt(limitParam, 10);
        const offset = offsetParam ? parseInt(offsetParam, 10) : 0;
        results = results.slice(offset, offset + limit);
      }

      await delay();
      return HttpResponse.json({ results, total }, { status: 200 });
    }
  ),
];
